module.exports = __webpack_public_path__ + "static/media/discontrol026.d490b3b3.jpg";